import './About.css';

function About() {
  return (
    <main className='About'>
      <h1>
        ABOUT RACCTUALITY
      </h1>
      <p>
        Racctuality is a small indie game development studio based in the United Kingdom. Currently, the studio is quite
        a small affair, comprising just one man. That's me! Though there's not much here at the moment, I hope that over
        time I can share my passion for development here by creating fun and well-polished games for all to enjoy.
      </p>
      <br/>
      <p>
        Currently, my efforts are focused primarily on Hail to the Chief, a round-based nation-building strategy game
        where you can take charge of your own fledgling settlement and transform it into a prosperous and powerful
        country. Though still early in development, I hope to be able to show you more about this exciting project
        very soon.
      </p>
      <br/>
      <p>
        As a side-project, I have also been working on a small incremental game called Decay, in which the player
        creates nuclear isotopes with the goal of discovering increasingly unstable nuclides with increasingly long
        decay chains.
      </p>
      <hr/>
      <h1>
        ABOUT ME
      </h1>
      <p>
        My name is Nathan, and I am a British developer currently working solo on these projects. I have always loved
        video games, and am delighted to finally be on this journey to share that passion with the world. I hope you
        will join me!
      </p>
      <br/>
      <p>
        Outside of game development, I have had a couple of different jobs working with data, both in data engineering
        and data science, though I am currently not in employment as I commit more of my time to this endeavour. I am
        also a keen musician, and hope to be able to use the medium of game development to share some of that music
        through writing soundtracks for my games.
      </p>
    </main>
  );
}

export default About;
